import React from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { useWebSettings } from '../../../Context/WebSettings/WebSettingsContext';

export const SessionExpiredPopup = ({
  active,
  onClose,
}) => {
  const { timerValue } = useWebSettings();

  return (
    <div className={`${styles.sessionExpiredPopup} popup ${active ? "show" : ""}`}>
        <div className={`${styles.popHeader} popup-header`}>
          <h2 className="title">Reservation Expired</h2>
          <h6 className="titleSub">Your reservation has expired because it was not confirmed within {timerValue} {Number(timerValue) === 1 ? 'minute' : 'minutes'}.</h6>
          <h6 className="titleSub">The selected time slot has been released and may no longer be available.</h6>
        </div>
        <div className={`popup-body`}></div>

        <div className={`${styles.footer} popup-footer`}>
          <BtnPrimary 
            label="Choose Another Time Slot" 
            handleClick={onClose} 
            customClass="w-100 no-icon"
          />
        </div>
    </div>
  )
}
